import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qbp756w3aa: FaireBrandEntity = {
  token: "b_qbp756w3aa",
  type: "brand",
  name: "FH KNIVES",
  avatarUrl:
    "https://cdn.faire.com/fastly/8bb645d5291f58490497b6c62bbfdbddf52ec489d682157370a8878af82b84b7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4319a58507cf8ea9f5f184e7029a087b9cb838a99348ce35c3f4f3bd9aa0608b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8bb645d5291f58490497b6c62bbfdbddf52ec489d682157370a8878af82b84b7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4319a58507cf8ea9f5f184e7029a087b9cb838a99348ce35c3f4f3bd9aa0608b.jpeg",
  location: "SC, USA",
  minimumOrderDollars: 58,
  rating: 5,
  reviewCount: 147,
  isTopShop: true,
  isInsider: true,
  description:
    'FH KNIVES\'s slogan "Looks Classy Works Sharply"\n\nIn 2019, FH Knives brand was started in Lisbon by the 3rd generation family business. We specialize in making Damascus, D2, Stainless steel, and high-carbon steel knives. From a history of providing a steady stream of successful products, FH KNIVES has earned the reputation for always delivering innovative designs manufactured with consistently high quality.\n\nIn a short span, FH KNIVES has sold more than 1,00,000+ units across the globe and has received 2500+ reviews with an overall rating of 4.6/5. This international success of our products proves our dedication to making the highest quality knives.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:47.078Z",
    importedBy: "entity-db-cli",
  },
};
